export function adobeTargetView(pathname) {
  var viewName = pathname;

  if (viewName.startsWith('/')) {
    viewName = viewName.substr(1);
    if (viewName === '') {
      viewName = 'home';
    }
  }
  
  if (typeof adobe != 'undefined' && adobe.target && typeof adobe.target.triggerView === 'function' && viewName) {
    adobe.target.triggerView(viewName);
  }
}